import { PropsWithChildren, createContext, useState } from 'react';

import { useLanguage } from './useLanguage';

export const LocalizationContext = createContext({
	languageID: '',
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	setLanguageID: (languageID: string) => {},
});

export function LocalizationScope(props: PropsWithChildren) {
	const language = useLanguage();

	const [languageID, setLanguageID] = useState(language.id);

	return (
		<LocalizationContext.Provider value={{ languageID, setLanguageID }}>
			{props.children}
		</LocalizationContext.Provider>
	);
}
